import script from "./ColumnHeaderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnHeaderMenu.vue?vue&type=script&setup=true&lang=js"

import "./ColumnHeaderMenu.vue?vue&type=style&index=0&id=7ff1bc1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff1bc1c"]])

export default __exports__